const POST_ADD_CART_REFRESH_DELAY_MS = 4000;
let isPostAddCartRefreshInFlight = false;

if (!customElements.get('product-info')) {
  class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.productId = this.dataset.productId;
    }

    setupEventListeners() {
      this.variantSelector?.addEventListener('change', this.onVariantChange.bind(this));

      if (this.quantitySelector) {
        this.quantitySelector.addEventListener('change', this.onQuantitySelectorEvent.bind(this));
        
        const plusButton = this.quantitySelector.querySelector('button[name="plus"]');
        const minusButton = this.quantitySelector.querySelector('button[name="minus"]');
        
        if (plusButton) {
          plusButton.addEventListener('click', this.onQuantitySelectorEvent.bind(this));
        }
        
        if (minusButton) {
          minusButton.addEventListener('click', this.onQuantitySelectorEvent.bind(this));
        }
      }
      
      document.getElementById('swiper-script')?.addEventListener('load', this.initSwiper.bind(this));
      document.addEventListener('liquid-ajax-cart:request-end', this.onCartUpdate.bind(this));

      this.setupSizeGuideEvents();
      this.setupLowStockIndicator();
      this.setupViewerCount();
      this.setupNotifyMePopup();
      this.setupReviewSummaryPopup();
    }

    setupSizeGuideEvents() {
      const sizeGuideOverlay = this.querySelector('.size-guide-overlay');
      const sizeGuideInner = this.querySelector('.size-guide--inner');
      
      // Prefer modal overlay approach whenever overlay markup exists (PDP + quick-add)
      if (sizeGuideOverlay) {
        const openFromTrigger = (event) => {
          const trigger = event.target.closest('.size-chart-trigger');
          if (!trigger || !this.contains(trigger)) return;
          event.preventDefault();
          sizeGuideOverlay.classList.add('active');
          document.body.style.overflow = 'hidden';
        };

        const closeModal = () => {
          sizeGuideOverlay.classList.remove('active');
          document.body.style.overflow = '';
        };
        
        // Handle size chart trigger clicks
        this.addEventListener('click', openFromTrigger);
        document.addEventListener('click', openFromTrigger);

        // Handle all overlay clicks (outside modal and close button)
        sizeGuideOverlay.addEventListener('click', (event) => {
          // Handle clicks outside modal to close it
          if (event.target === sizeGuideOverlay) {
            closeModal();
            return;
          }
          
          // Handle close button clicks
          const closeBtn = event.target.closest('.size-guide-close');
          if (closeBtn) {
            event.preventDefault();
            event.stopPropagation();
            closeModal();
            return;
          }
        });
        
        // Prevent closing when clicking inside modal content (but allow close button to work)
        if (sizeGuideInner) {
          sizeGuideInner.addEventListener('click', (event) => {
            // Allow close button clicks to propagate to overlay handler
            if (!event.target.closest('.size-guide-close')) {
              event.stopPropagation();
            }
          });
        }
        
        // Close on ESC key
        const escHandler = (event) => {
          if (event.key === 'Escape' && sizeGuideOverlay.classList.contains('active')) {
            closeModal();
          }
        };
        document.addEventListener('keydown', escHandler);
        return;
      }
      
      // Fallback for templates without overlay markup
      if (sizeGuideInner) {
        const openFromTrigger = (event) => {
          const trigger = event.target.closest('.size-chart-trigger');
          if (!trigger || !this.contains(trigger)) return;
          event.preventDefault();
          sizeGuideInner.style.display = 'block';
          document.body.style.overflow = 'hidden';
        };

        // Use event delegation to handle dynamically created elements
        this.addEventListener('click', (event) => {
          // Handle size chart trigger clicks
          if (event.target.matches('.size-chart-trigger') || event.target.closest('.size-chart-trigger')) {
            if (sizeGuideInner) {
              event.preventDefault();
              sizeGuideInner.style.display = 'block';
              document.body.style.overflow = 'hidden';
            }
          }
          
          // Handle size guide close clicks
          if (event.target.matches('.size-guide-close') || event.target.closest('.size-guide-close')) {
            if (sizeGuideInner) {
              sizeGuideInner.style.display = 'none';
              document.body.style.overflow = '';
            }
          }
          
          // Handle clicks on size guide background to close
          if (event.target === sizeGuideInner) {
            sizeGuideInner.style.display = 'none';
            document.body.style.overflow = '';
          }
        });
        document.addEventListener('click', openFromTrigger);

        // Handle clicks outside sizeGuideInner to close it
        document.addEventListener('click', (event) => {
          if (!sizeGuideInner) return;
          
          if (sizeGuideInner.style.display === 'block') {
            const isClickInside = sizeGuideInner.contains(event.target);
            const isTriggerClick = event.target.matches('.size-chart-trigger') || event.target.closest('.size-chart-trigger');
            
            if (!isClickInside && !isTriggerClick) {
              sizeGuideInner.style.display = 'none';
              document.body.style.overflow = '';
            }
          }
        });
      }
    }

    setupLowStockIndicator() {
      this.updateLowStockIndicator();
      this.updatePreOrderProperty();
      
      document.addEventListener('click', (event) => {
        if (event.target.matches('input.pill-radio')) {
          this.updateLowStockIndicator();
          this.updatePreOrderProperty();
        }
      });
    }

    updateLowStockIndicator() {
      const checkedPillRadio = document.querySelector('input.pill-radio:checked');
      const lowStockDiv = document.querySelector('.low-stock-indicator');
      
      if (checkedPillRadio && lowStockDiv) {
        if (checkedPillRadio.getAttribute('data-low-stock') === 'true') {
          lowStockDiv.style.display = 'block';
        } else {
          lowStockDiv.style.display = 'none';
        }
      } else if (lowStockDiv) {
        lowStockDiv.style.display = 'none';
      }
    }

    updatePreOrderProperty(variant) {
      const packInfoInput = document.querySelector('#pack-info-property');
      
      if (!packInfoInput) return;
      
      // If no variant passed, try to get it from the current selection
      if (!variant) {
        const checkedPillRadio = document.querySelector('input.pill-radio:checked');
        const isPreOrder = checkedPillRadio && checkedPillRadio.hasAttribute('Pre-order-true');
        
        if (!isPreOrder) {
          packInfoInput.disabled = true;
          packInfoInput.value = '';
          packInfoInput.removeAttribute('data-preorder-delivery-date');
          return;
        }
      }
      
      let deliveryDate = '';
      
      // Check if atc-text span has variant delivery date (highest priority)
      const atcTextSpan = document.querySelector('.atc-text');
      if (atcTextSpan && atcTextSpan.hasAttribute('variant-pre-order-delivery-date')) {
        deliveryDate = atcTextSpan.getAttribute('variant-pre-order-delivery-date');
      }
      // Fallback to input's own attribute
      else if (packInfoInput.hasAttribute('data-preorder-delivery-date')) {
        deliveryDate = packInfoInput.getAttribute('data-preorder-delivery-date');
      }
      
      if (deliveryDate) {
        packInfoInput.value = 'Estimated delivery date is ' + deliveryDate + '.';
        packInfoInput.disabled = false;
      } else {
        packInfoInput.removeAttribute('data-preorder-delivery-date');
        packInfoInput.value = 'Not Available';
        packInfoInput.disabled = true;
      }
    }

    setupViewerCount() {
      if (!this.productId) return;
      
      // Generate a somewhat random but stable number between 3-15 based on product ID
      const baseNumber = ((parseInt(this.productId) % 10) + 3);
      const randomVariation = Math.floor(Math.random() * 5);
      const viewers = baseNumber + randomVariation;

      const viewerElement = this.querySelector('#current-viewers');
      if (viewerElement) {
        viewerElement.textContent = viewers;
      }
    }

    setupNotifyMePopup() {
      this.addEventListener('click', (event) => {
        if (event.target.matches('.notify-me-popup-trigger') || event.target.closest('.notify-me-popup-trigger')) {
          const notifyMePopup = this.querySelector('notify-me-popup');
          if (notifyMePopup) {
            notifyMePopup.show();
          }
        }
      });
    }

    setupReviewSummaryPopup() {
      // Use event delegation on the product-info element (doesn't get replaced)
      this.addEventListener('click', (event) => {
        // Toggle tooltip on link click
        if (event.target.matches('.reveiws_summary') || event.target.closest('.reveiws_summary')) {
          event.preventDefault();
          const tooltip = event.target.closest('.review-summary-wrapper')?.querySelector('.review-summary--tooltip');
          if (tooltip) {
            tooltip.style.display = tooltip.style.display === 'none' ? 'block' : 'none';
          }
        }
        
        // Close tooltip when clicking view button
        if (event.target.matches('.review-summary--view-btn') || event.target.closest('.review-summary--view-btn')) {
          const tooltip = event.target.closest('.review-summary-wrapper')?.querySelector('.review-summary--tooltip');
          if (tooltip) {
            tooltip.style.display = 'none';
          }
        }
        
        // Close tooltip when clicking close button (if it exists)
        const closeButton = event.target.closest('.review-summary--header .close-button');
        if (closeButton) {
          const tooltip = closeButton.closest('.review-summary--tooltip');
          if (tooltip) {
            tooltip.style.display = 'none';
          }
        }
      });

      // Close tooltip when clicking outside
      document.addEventListener('click', (event) => {
        // Don't cache the tooltip - query it each time
        const allTooltips = this.querySelectorAll('.review-summary--tooltip');
        allTooltips.forEach(tooltip => {
          if (tooltip && !event.target.closest('.review-summary-wrapper') && tooltip.style.display === 'block') {
            tooltip.style.display = 'none';
          }
        });
      });
    }

    connectedCallback() {
      this.setupEventListeners();
      if (typeof Swiper !== 'undefined') {
        this.initSwiper();
      }

      setTimeout(() => {
        this.updateAddToCartVisibilityOnLoad();
      }, 100);

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          this.updateAddToCartVisibilityOnLoad();
        });
      } else {
        setTimeout(() => {
          this.updateAddToCartVisibilityOnLoad();
        }, 200);
      }

      window.Shop = window.Shop || {};
      window.Shop.productInfoEl = this;
    }

    initSwiper() {
      const isInQuickAddModal = this.closest('quick-add-modal') !== null;
      const isGameDaySocksTemplate = document.body.classList.contains('product-template-suffix-game-day-socks-new');
      const forceSingleSlideView = isInQuickAddModal || isGameDaySocksTemplate;
      const sliderElement = this.querySelector('.gallery-slider');
      if (!sliderElement) return;
      
      // Use scoped navigation elements so each modal controls its own slider
      const navPrevSelector = isInQuickAddModal ? '.swiper-button-modal.swiper-button-prev' : '.swiper-button-pdp.swiper-button-prev';
      const navNextSelector = isInQuickAddModal ? '.swiper-button-modal.swiper-button-next' : '.swiper-button-pdp.swiper-button-next';
      const navPrevElement = this.querySelector(navPrevSelector);
      const navNextElement = this.querySelector(navNextSelector);
      const paginationElement = this.querySelector('.swiper-pagination');

      if (this.swiper && typeof this.swiper.destroy === 'function') {
        this.swiper.destroy(true, true);
      }

      this.swiper = new Swiper(sliderElement, {
        autoHeight: true,
        direction: 'horizontal',
        loop: false,
        slidesPerView: 1,
        spaceBetween: 4,
        ...(!forceSingleSlideView && {
          breakpoints: {
            1025: {
              slidesPerView: 2,
            },
          },
        }),
        ...(paginationElement && {
          pagination: {
            el: paginationElement,
          },
        }),
        navigation: {
          prevEl: navPrevElement,
          nextEl: navNextElement,
        },
        on: {
          slideChange: () => {
            this.updateThumbnailActive();
          },
        }
      });
      
      this.initThumbnails();
    }

    initThumbnails() {
      const thumbnails = this.querySelectorAll('.thumbnail-item');
      thumbnails.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          this.swiper?.slideTo(index);
        });
      });
      this.updateThumbnailActive();
    }

    initThumbnailClicks() {
      // This method is no longer needed
    }

    updateThumbnailActive() {
      const thumbnails = this.querySelectorAll('.thumbnail-item');
      thumbnails.forEach((thumb, index) => {
        thumb.classList.toggle('active', index === this.swiper?.activeIndex);
      });
    }

    onCartUpdate(e) {
      if (!window.location.pathname.includes('/products/')) return;
      const { requestState } = e.detail;
      // If the "add to cart" request is successful
      if (requestState.requestType === 'add' && requestState.responseData?.ok) {
        const responseBody = requestState?.responseData?.body;

        this.refreshCartAfterAdd(() => {
          // Add the CSS class to the "body" tag
          document.body.classList.add('js-show-ajax-cart');
          // dispatch a custom event
          document.dispatchEvent(
            new CustomEvent('item-added-to-cart', {
              detail: responseBody,
            })
          );
        });
      }
    }

    refreshCartAfterAdd(onComplete) {
      if (typeof onComplete !== 'function') return;
      if (isPostAddCartRefreshInFlight) return;

      const canUpdate = typeof window.liquidAjaxCart?.update === 'function';
      const canGet = typeof window.liquidAjaxCart?.get === 'function';
      if (!canUpdate && !canGet) {
        onComplete();
        return;
      }

      isPostAddCartRefreshInFlight = true;
      const finalizeRefresh = () => {
        isPostAddCartRefreshInFlight = false;
        onComplete();
      };

      setTimeout(() => {
        if (canUpdate) {
          window.liquidAjaxCart.update(
            {},
            {
              lastCallback: () => {
                finalizeRefresh();
              },
            }
          );
          return;
        }

        Promise.resolve(window.liquidAjaxCart.get())
          .catch(() => {})
          .finally(() => {
            finalizeRefresh();
          });
      }, POST_ADD_CART_REFRESH_DELAY_MS);
    }

    get variantSelector() {
      return this.querySelector('variant-selector');
    }

    get quantitySelector() {
      return this.querySelector('quantity-selector');
    }

    get selectedOptionValues() {
      if (this.variantSelector.dataset.pickerType === 'dropdown') {
        const list = Array.from(this.variantSelector.querySelectorAll('select')).map(
          (select) => select.options[select.selectedIndex].dataset.optionValueId
        );
        return list;
      } else {
        const list = Array.from(this.variantSelector.querySelectorAll('fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
        return list;
      }
    }

    getSelectedVariant(html) {
      const selectedVariant = html.querySelector('[data-selected-variant]')?.innerHTML;
      if (!selectedVariant) return null;

      try {
        return JSON.parse(selectedVariant);
      } catch {
        return null;
      }
    }

    resolveQuickAddProductUrl(e) {
      const eventProductUrl = e.target?.dataset?.productUrl;
      if (eventProductUrl) return eventProductUrl;

      const topLevelActiveColor = this.querySelector(':scope > color-variants .color-variant-single.active[data-product-url]');
      if (topLevelActiveColor?.dataset?.productUrl) return topLevelActiveColor.dataset.productUrl;

      const attachedActiveColor = this.querySelector(
        'style-variants .color-variant-single.active .colors-attached-with-style color-variants .color-variant-single.active[data-product-url]'
      );
      if (attachedActiveColor?.dataset?.productUrl) return attachedActiveColor.dataset.productUrl;

      const visibleActiveColor = Array.from(
        this.querySelectorAll('color-variants .color-variant-single.active[data-product-url]')
      ).find((colorItem) => {
        const attachedWrapper = colorItem.closest('.colors-attached-with-style');
        if (!attachedWrapper) return true;
        const parentStyle = attachedWrapper.closest('style-variants .color-variant-single');
        return !!parentStyle?.classList.contains('active');
      });

      if (visibleActiveColor?.dataset?.productUrl) return visibleActiveColor.dataset.productUrl;
      return this.dataset.url;
    }

    getSelectedOptionTextValues() {
      if (!this.variantSelector) return [];
      if (this.variantSelector.dataset.pickerType === 'dropdown') {
        return Array.from(this.variantSelector.querySelectorAll('select')).map(
          (select) => select.options[select.selectedIndex]?.value
        ).filter(Boolean);
      }

      return Array.from(this.variantSelector.querySelectorAll('fieldset input:checked')).map(
        (input) => input.value
      ).filter(Boolean);
    }

    getActiveProductDataJson() {
      const activeScopedColorNode = this.querySelector(
        ':scope > color-variants .color-variant-single.active[data-product-json]'
      );
      if (activeScopedColorNode?.dataset?.productJson) return activeScopedColorNode.dataset.productJson;

      const activeNestedColorNode = this.querySelector(
        'style-variants .color-variant-single.active .colors-attached-with-style color-variants .color-variant-single.active[data-product-json]'
      );
      if (activeNestedColorNode?.dataset?.productJson) return activeNestedColorNode.dataset.productJson;

      const activeColorNode = this.querySelector('color-variants .color-variant-single.active[data-product-json]');
      if (activeColorNode?.dataset?.productJson) return activeColorNode.dataset.productJson;

      const anyProductDataNode = this.querySelector('[data-product-json]');
      if (anyProductDataNode?.dataset?.productJson) return anyProductDataNode.dataset.productJson;

      return null;
    }

    resolveVariantFromActiveProductData() {
      const productDataString = this.getActiveProductDataJson();
      if (!productDataString) return null;

      let productData;
      try {
        productData = JSON.parse(productDataString);
      } catch {
        return null;
      }

      const selectedOptionValues = this.getSelectedOptionTextValues();
      if (!selectedOptionValues.length) return productData?.variants?.[0] || null;

      const matchedVariant = productData.variants?.find((variant) => {
        const variantOptions = Array.isArray(variant.options) && variant.options.length
          ? variant.options
          : [variant.option1, variant.option2, variant.option3].filter(Boolean);
        if (!variantOptions.length) return false;
        return selectedOptionValues.every((value, index) => variantOptions[index] === value);
      });

      return matchedVariant || null;
    }

    getQuickAddProductDataByUrl(productUrl) {
      const escapedUrl = (window.CSS && typeof window.CSS.escape === 'function')
        ? window.CSS.escape(productUrl)
        : productUrl.replace(/"/g, '\\"');

      const topLevelNode = this.querySelector(
        `:scope > color-variants .color-variant-single[data-product-url="${escapedUrl}"][data-product-json]`
      );
      if (topLevelNode?.dataset?.productJson) return topLevelNode.dataset.productJson;

      const attachedNode = this.querySelector(
        `style-variants .color-variant-single.active .colors-attached-with-style color-variants .color-variant-single[data-product-url="${escapedUrl}"][data-product-json]`
      );
      if (attachedNode?.dataset?.productJson) return attachedNode.dataset.productJson;

      const anyNode = this.querySelector(
        `.color-variant-single[data-product-url="${escapedUrl}"][data-product-json]`
      );
      return anyNode?.dataset?.productJson || null;
    }

    resolveQuickAddVariantFallback(productUrl) {
      const productDataString = this.getQuickAddProductDataByUrl(productUrl);
      if (!productDataString) return null;

      let productData;
      try {
        productData = JSON.parse(productDataString);
      } catch {
        return null;
      }

      const selectedOptionValues = this.getSelectedOptionTextValues();
      if (!selectedOptionValues.length) return productData?.variants?.[0] || null;

      const matchedVariant = productData.variants?.find((variant) => {
        const variantOptions = Array.isArray(variant.options) && variant.options.length
          ? variant.options
          : [variant.option1, variant.option2, variant.option3].filter(Boolean);
        if (!variantOptions.length) return false;

        return selectedOptionValues.every((value, index) => variantOptions[index] === value);
      });

      return matchedVariant || productData?.variants?.[0] || null;
    }

    async resolveVariantFromProductEndpoint(productUrl) {
      const selectedOptionValues = this.getSelectedOptionTextValues();
      if (!selectedOptionValues.length) return null;

      const normalizedProductUrl = String(productUrl || '').split('?')[0];
      if (!normalizedProductUrl) return null;

      try {
        const response = await fetch(`${normalizedProductUrl}.js`);
        if (!response.ok) return null;
        const productData = await response.json();
        const matchedVariant = productData?.variants?.find((variant) => {
          const variantOptions = Array.isArray(variant.options) && variant.options.length
            ? variant.options
            : [variant.option1, variant.option2, variant.option3].filter(Boolean);
          if (!variantOptions.length) return false;
          return selectedOptionValues.every((value, index) => variantOptions[index] === value);
        });
        return matchedVariant || null;
      } catch {
        return null;
      }
    }

    onVariantChange(e) {
      const isInQuickAddModal = this.closest('quick-add-modal') !== null;
      
      let hasDifferentProductUrl = false;
      let productUrl = this.dataset.url;
      
      if (isInQuickAddModal) {
        productUrl = this.resolveQuickAddProductUrl(e);
        hasDifferentProductUrl = productUrl !== this.dataset.url;
      } else {
        hasDifferentProductUrl = e.target?.dataset?.productUrl ? (e.target?.dataset?.productUrl !== this.dataset.url) : false;
        productUrl = e.target?.dataset?.productUrl || this.dataset.url;
      }
      
      const localVariant = this.resolveVariantFromActiveProductData();
      if (localVariant?.id) {
        this.updateVariantInputs(localVariant.id);
        this.updateAddToCartVisibility(localVariant);
        this.updatePreOrderProperty(localVariant);
      }

      this.updatePreOrderProperty();
      this.renderSection(hasDifferentProductUrl, productUrl);
    }

    onQuantitySelectorEvent(e) {
      // Add null check for quantity selector
      if (!this.quantitySelector) return;
      
      const quantityInput = this.quantitySelector.querySelector('input[type="number"]');
      if (!quantityInput) return;
      
      let currentValue = parseInt(quantityInput.value);
      const minValue = parseInt(quantityInput.getAttribute('min')) || 0;
      const maxValue = parseInt(quantityInput.getAttribute('max')) || Infinity;

      if (e.target.name === 'minus' && currentValue > minValue) {
        quantityInput.value = currentValue - 1;
      } else if (e.target.name === 'plus' && currentValue < maxValue) {
        quantityInput.value = currentValue + 1;
      } else if (e.type === 'change') {
        if (currentValue < minValue) {
          quantityInput.value = minValue;
        } else if (currentValue > maxValue) {
          quantityInput.value = maxValue;
        }
      }
    }

    updateMedia(variantFeaturedMediaId) {
      if (!variantFeaturedMediaId) return;
      const mediaSlide = this.querySelector(`.swiper-slide[data-media-id="${variantFeaturedMediaId}"]`);
      if (!mediaSlide) return;

      const index = mediaSlide.dataset.mediaIndex;
      if (typeof index === 'undefined') return;

      this.swiper?.slideTo(index);
    }

    updateURL(variantId) {
      // this.querySelector('share-button')?.updateUrl(
      //   `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
      // );
      if (!window.location.pathname.includes('/products/')) return;
      window.history.replaceState({}, '', `${this.dataset.url}${variantId ? `?variant=${variantId}` : ''}`);
    }

    updateDiscountPricing(variant) {
      if (!variant || typeof discount_applied_25 === 'undefined') return;
      
      // Check if any discount is applied
      if (discount_applied_25 || discount_applied_30 || discount_applied_40 || collection_custom || site_wide) {
        const priceContainer = this.querySelector('.price');
        
        if (priceContainer && typeof discount_value !== 'undefined') {
          // Calculate discounted price
          const discountedPrice = Math.round(variant.price * discount_value);
          
          // Update current price elements
          const regularPriceElements = priceContainer.querySelectorAll('.price-item--regular');
          const salePriceElements = priceContainer.querySelectorAll('.price-item--sale');
          
          // Update the displayed prices
          regularPriceElements.forEach(element => {
            if (!element.closest('s')) { // Only update non-crossed out prices
              element.innerHTML = this.formatMoney(discountedPrice);
            }
          });
          
          salePriceElements.forEach(element => {
            element.innerHTML = this.formatMoney(discountedPrice);
          });
          
          // Show compare price (original price crossed out)
          const comparePriceElements = priceContainer.querySelectorAll('s .price-item--regular');
          comparePriceElements.forEach(element => {
            element.innerHTML = this.formatMoney(variant.price);
          });
          
          // Add sale class to price container
          priceContainer.classList.add('price--on-sale');
        }
      }
    }

    updateAddToCartVisibility(variant) {
      const addToCartForm = this.querySelector('ajax-cart-product-form');
      const notifyMeTrigger = this.querySelector('.notify-me-popup-trigger');
      const addToCartButton = this.querySelector('button[name="add"]');
      
      if (!addToCartForm || !notifyMeTrigger) return;
      
      const checkedPillRadio = this.querySelector('input.pill-radio:checked');
      const isPillMarkedUnavailable = checkedPillRadio
        ? checkedPillRadio.classList.contains('disabled') || checkedPillRadio.hasAttribute('disabled')
        : false;
      const isVariantAvailableFromData = typeof variant?.available === 'boolean'
        ? variant.available
        : !addToCartButton?.disabled;
      const isVariantAvailable = !isPillMarkedUnavailable && isVariantAvailableFromData;
      
      if (isVariantAvailable) {
        addToCartForm.style.display = 'block';
        notifyMeTrigger.style.display = 'none';
      } else {
        addToCartForm.style.display = 'none';
        notifyMeTrigger.style.display = 'block';
      }
    }

    updateAddToCartVisibilityOnLoad() {
      const variantInput = this.querySelector('input[name="id"]');
      if (!variantInput) return;
    
      const currentVariantId = variantInput.value;
      if (!currentVariantId) return;
    
      const productData =
        this.querySelector('.color-variant-single.active[data-product-json]') ||
        this.querySelector('.color-variant-single[data-product-json]') ||
        this.querySelector('[data-product-json]') ||
        document.querySelector('.color-variant-single.active[data-product-json]') ||
        document.querySelector('.color-variant-single[data-product-json]') ||
        document.querySelector('[data-product-json]');
    
      if (!productData) {
        this.updateAddToCartVisibilityOnLoadFallback();
        return;
      }

      const rawJson = productData.hasAttribute('data-product-json')
        ? productData.getAttribute('data-product-json')?.trim()
        : productData.textContent?.trim();
    
      if (!rawJson) {
        this.updateAddToCartVisibilityOnLoadFallback();
        return;
      }
    
      let product;
    
      try {
        product = JSON.parse(rawJson);
      } catch {
        this.updateAddToCartVisibilityOnLoadFallback();
        return;
      }
    
      const variant = product.variants?.find(
        v => v.id.toString() === currentVariantId.toString()
      );
    
      if (variant) {
        this.updateAddToCartVisibility(variant);
        this.updatePreOrderProperty(variant);
      } else {
        this.updateAddToCartVisibilityOnLoadFallback();
      }
    }

    updateAddToCartVisibilityOnLoadFallback() {
      const addToCartButton = this.querySelector('button[name="add"]');
      const addToCartForm = this.querySelector('ajax-cart-product-form');
      const notifyMeTrigger = this.querySelector('.notify-me-popup-trigger');
      
      if (!addToCartButton || !addToCartForm || !notifyMeTrigger) return;
      
      const isVariantAvailable = !addToCartButton.disabled;
      
      if (isVariantAvailable) {
        addToCartForm.style.display = 'block';
        notifyMeTrigger.style.display = 'none';
      } else {
        addToCartForm.style.display = 'none';
        notifyMeTrigger.style.display = 'block';
      }
    }

    formatMoney(cents) {
      // Use Shopify's money formatting if available, otherwise fallback to basic formatting
      if (typeof window.moneyFormat !== 'undefined' && window.moneyFormat) {
        return window.moneyFormat.replace('{{amount}}', (cents / 100).toFixed(2)).replace('{{amount_no_decimals}}', Math.round(cents / 100));
      } else if (typeof current_currency !== 'undefined') {
        return `${current_currency}${(cents / 100).toFixed(2)}`;
      } else {
        return `$${(cents / 100).toFixed(2)}`;
      }
    }

    updateSourceFromDestination = (html, id) => {
      const source = html.getElementById(`${id}`);
      const destination = this.querySelector(`#${id}`);
      if (source && destination) {
        destination.innerHTML = source.innerHTML;
      }
    };

    updateVariantInputs(variantId) {
      this.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`).forEach(
        (productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
        }
      );
    }

    renderSection(hasDifferentProductUrl, productUrl) {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const isInQuickAddModal = this.closest('quick-add-modal') !== null;
      const selectedOptionValueIds = this.selectedOptionValues.filter(Boolean);
      const queryParts = [`section_id=${encodeURIComponent(this.dataset.section)}`];
      if (selectedOptionValueIds.length) {
        queryParts.unshift(`option_values=${encodeURIComponent(selectedOptionValueIds.join(','))}`);
      }

      fetch(`${productUrl}?${queryParts.join('&')}`, {
        signal: this.abortController.signal,
      })
        .then((response) => response.text())
        .then(async (responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          let variant = this.getSelectedVariant(html);
          if (!variant) {
            variant = this.resolveVariantFromActiveProductData();
          }
          if (!variant && isInQuickAddModal) {
            variant = this.resolveQuickAddVariantFallback(productUrl);
          }
          if (!variant) {
            variant = await this.resolveVariantFromProductEndpoint(productUrl);
          }
          if (hasDifferentProductUrl) {
            const productInfo = html.querySelector('product-info');
            this.replaceWith(productInfo);
            if (variant?.id) {
              productInfo.updateVariantInputs(variant.id);
            }
            productInfo.updateURL(variant?.id);
          } else {
            this.updateMedia(variant?.featured_media?.id);
            this.updateURL(variant?.id);
            if (variant?.id) {
              this.updateVariantInputs(variant.id);
            }
            this.updateSourceFromDestination(html, `add-to-cart-container-${this.dataset.section}`);
            this.updateSourceFromDestination(html, `variant-selector-${this.dataset.section}`);
            this.updateSourceFromDestination(html, `price-${this.dataset.section}`);
            this.updateSourceFromDestination(html, `sku-${this.dataset.section}`);
            this.updateSourceFromDestination(html, `inventory-${this.dataset.section}`);
            
            // Apply discount pricing if applicable
            this.updateDiscountPricing(variant);
            this.updateAddToCartVisibility(variant);
            this.updatePreOrderProperty(variant);
          }
        })
        .catch((error) => {
          if (error.name === 'AbortError') {
            return;
          } else {
            console.error(error);
          }
        });
    }
  }

  customElements.define('product-info', ProductInfo);
}